import type { Messages } from './en';

/** नेपाली (Nepal). Same keys as en.ts; placeholders like {name} stay as they are. */
export const ne: Messages = {
  'common.retry': 'फेरि प्रयास गर्नुहोस्',
  'common.save': 'सेभ गर्नुहोस्',
  'common.saving': 'सेभ हुँदैछ…',
  'common.cancel': 'रद्द गर्नुहोस्',
  'common.back': 'पछाडि',
  'common.edit': 'सम्पादन',
  'common.delete': 'हटाउनुहोस्',
  'common.keep': 'राख्नुहोस्',
  'common.discard': 'छोड्नुहोस्',
  'common.change': 'परिवर्तन',
  'common.draftRestored': 'तपाईंले पछिल्लो पटक लेखेको हामीले राखेका छौं।',
  'common.draftSaved': 'ड्राफ्ट सेभ भयो',
  'common.wrong': 'केही गडबड भयो। फेरि प्रयास गर्नुहोस्।',
  'common.supportRef': 'यो कोड सपोर्टलाई दिनुहोस्',
  'common.copyRef': 'कोड कपी गर्नुहोस्',
  'common.refCopied': 'कोड कपी भयो',
  'common.offline': 'तपाईं अफलाइन हुनुहुन्छ। अन्तिम पटक लोड भएको देखाउँदैछौं।',
  'common.unreachable': 'Capsico सँग जोडिन सकिएन',
  'common.unreachableBody': 'आफ्नो इन्टरनेट जडान जाँच गर्नुहोस्।',

  'nav.home': 'होम',
  'nav.search': 'खोज्नुहोस्',
  'nav.account': 'खाता',

  'location.deliverTo': 'डेलिभरी ठाउँ',
  'location.choose': 'डेलिभरी ठाउँ छान्नुहोस्',
  'location.useCurrent': 'मेरो अहिलेको लोकेसन प्रयोग गर्नुहोस्',
  'location.locating': 'तपाईंलाई खोज्दैछौं…',
  'location.denied': 'लोकेसन बन्द छ। खोल्नुहोस्, वा तल आफ्नो सहर छान्नुहोस्।',
  'location.unavailable': 'तपाईंको लोकेसन पाइएन। तल आफ्नो सहर छान्नुहोस्।',
  'location.saved': 'सेभ गरिएका ठेगाना',
  'location.towns': 'वा आफ्नो सहर छान्नुहोस्',
  'location.addAddress': 'नयाँ ठेगाना थप्नुहोस्',
  'location.signInToSave': 'ठेगाना सेभ गर्न साइन इन गर्नुहोस्',
  'location.current': 'अहिलेको लोकेसन',
  'location.townCentre': '{town} (सहरको बीच)',
  'location.setFirst': 'कहाँ डेलिभर गर्ने भन्नुहोस्, नजिकै खुला रेस्टुरेन्ट देखाउँछौं।',
  'location.notServed': 'यहाँ अहिले डेलिभरी छैन',

  'signin.title': 'भोक लाग्यो? साइन इन गर्नुहोस् 🍛',
  'signin.subtitle': 'आफ्नो मोबाइल नम्बर हाल्नुहोस्। हामी ६ अङ्कको कोड पठाउँछौं।',
  'signin.phone': 'मोबाइल नम्बर',
  'signin.sendCode': 'कोड पठाउनुहोस्',
  'signin.codeTitle': '{sentTo} मा पठाएको कोड हाल्नुहोस्',
  'signin.code': '६ अङ्कको कोड',
  'signin.verify': 'पुष्टि गर्नुहोस्',
  'signin.resendIn': '{seconds} सेकेन्डमा फेरि पठाउनुहोस्',
  'signin.resend': 'कोड फेरि पठाउनुहोस्',
  'signin.changeNumber': 'नम्बर परिवर्तन',
  'signin.smsDelayed': 'SMS ढिलो आउँदैछ। नआए Capsico सपोर्टसँग कोड माग्नुहोस्।',
  'signin.terms': 'अगाडि बढेर तपाईं हाम्रा सर्त र गोपनीयता नीति स्वीकार गर्नुहुन्छ।',
  'signin.browse': 'हेर्दै मात्र — अहिले छोड्नुहोस्',
  'signin.enterPhone': 'आफ्नो मोबाइल नम्बर हाल्नुहोस्',
  'signin.enterCode': '६ अङ्कको कोड हाल्नुहोस्',
  'turnstile.label': 'सुरक्षा जाँच',
  'turnstile.required': 'कृपया माथिको जाँच पूरा गरेर फेरि प्रयास गर्नुहोस्।',
  'turnstile.failed': 'तपाईं मानिस हुनुहुन्छ भनी पुष्टि गर्न सकिएन। कृपया जाँच फेरि गर्नुहोस्।',

  'profile.title': 'आफ्नो बारेमा थोरै',
  'profile.subtitle': 'ताकि हामी सही खाना देखाऊँ र तपाईंलाई नामले बोलाऊँ।',
  'profile.name': 'तपाईंको नाम',
  'profile.namePlaceholder': 'जस्तै सीता श्रेष्ठ',
  'profile.diet': 'तपाईं के खानुहुन्छ?',
  'profile.veg': 'शाकाहारी मात्र',
  'profile.nonVeg': 'शाकाहारी र मांसाहारी',
  'profile.email': 'इमेल (ऐच्छिक)',
  'profile.emailPlaceholder': 'बिलका लागि, स्प्याम कहिल्यै होइन',
  'profile.birthday': 'जन्मदिन (ऐच्छिक)',
  'profile.birthdayHint': 'तपाईंको दिनमा एउटा ट्रिट 🎂',
  'profile.language': 'एपको भाषा',
  'profile.save': 'सेभ गरेर अगाडि बढ्नुहोस्',
  'profile.saved': 'प्रोफाइल सेभ भयो',
  'profile.nameRequired': 'आफ्नो नाम भन्नुहोस् (कम्तीमा २ अक्षर)',
  'profile.dietRequired': 'शाकाहारी वा मांसाहारी छान्नुहोस्',
  'profile.edit': 'प्रोफाइल सम्पादन',

  'address.title': 'ठेगाना थप्नुहोस्',
  'address.editTitle': 'ठेगाना सम्पादन',
  'address.pinHint': 'नक्सा सारेर पिन आफ्नो गेटमा राख्नुहोस्',
  'address.house': 'घर / फ्ल्याट नम्बर',
  'address.floor': 'तल्ला (ऐच्छिक)',
  'address.area': 'बाटो र टोल',
  'address.landmark': 'नजिकको चिनारी (ऐच्छिक)',
  'address.landmarkPlaceholder': 'जस्तै मन्दिरको अगाडि',
  'address.instructions': 'राइडरका लागि नोट (ऐच्छिक)',
  'address.instructionsPlaceholder': 'जस्तै घण्टी दुई पटक बजाउनुहोस्, कुकुर टोक्दैन',
  'address.saveAs': 'यो नामले सेभ गर्नुहोस्',
  'address.home': 'घर',
  'address.work': 'अफिस',
  'address.other': 'अन्य',
  'address.otherName': 'यो ठाउँको नाम',
  'address.otherPlaceholder': 'जस्तै होस्टल, आमाको घर',
  'address.someoneElse': 'अरू कसैका लागि अर्डर?',
  'address.receiverName': 'उहाँको नाम',
  'address.receiverPhone': 'उहाँको मोबाइल नम्बर',
  'address.gatePhoto': 'गेटको फोटो',
  'address.gatePhotoHint': 'राइडरले पहिलो पटकमै बाटो भेट्छन्',
  'address.addPhoto': 'फोटो थप्नुहोस्',
  'address.replace': 'बदल्नुहोस्',
  'address.remove': 'हटाउनुहोस्',
  'address.voiceNote': 'आवाजमा बाटो',
  'address.voiceHint': '६० सेकेन्डसम्म — "चिया पसलपछि बायाँ मोडिनुहोस्…"',
  'address.record': 'रेकर्ड गर्नुहोस्',
  'address.stop': 'रोक्नुहोस्',
  'address.recording': 'रेकर्ड हुँदैछ {time}',
  'address.uploading': 'अपलोड {percent}%',
  'address.micDenied': 'माइक बन्द छ। बाटो रेकर्ड गर्न अनुमति दिनुहोस्।',
  'address.makeDefault': 'यसलाई मेरो मुख्य ठेगाना बनाउनुहोस्',
  'address.save': 'ठेगाना सेभ गर्नुहोस्',
  'address.saved': 'ठेगाना सेभ भयो',
  'address.deleted': 'ठेगाना हटाइयो',
  'address.deleteConfirm': 'यो ठेगाना हटाउने?',
  'address.default': 'मुख्य',
  'address.setDefault': 'मुख्य बनाउनुहोस्',
  'address.notServed': 'यहाँ अहिले डेलिभरी हुँदैन',
  'address.none': 'अहिलेसम्म कुनै ठेगाना सेभ छैन',
  'address.noneBody': 'घर र अफिस एक पटक सेभ गर्नुहोस् — अर्डर छिटो हुन्छ।',

  'vote.title': 'Capsico यहाँ अझै छैन… अहिलेसम्म 🛵',
  'vote.body': 'यो क्षेत्रबाट हरेक भोटले यसलाई हाम्रो सुरु सूचीमा माथि ल्याउँछ।',
  'vote.cta': 'Capsico यहाँ ल्याउनुहोस्',
  'vote.voted': 'भोट गनियो! हामी आएपछि तपाईंलाई खबर गर्छौं।',
  'vote.already': 'तपाईंले यो क्षेत्रका लागि भोट गरिसक्नुभयो। धन्यवाद!',
  'vote.nearby': 'तपाईंको नजिक {count} जना Capsico चाहन्छन्',
  'vote.notify': 'सुरु हुँदा खबर पाउन फोन नम्बर (ऐच्छिक)',
  'vote.otherPlace': 'अर्को ठाउँ हेर्नुहोस्',

  'account.title': 'खाता',
  'account.signedOutTitle': 'तपाईंको खाना, तपाईंकै तरिकाले',
  'account.signedOutBody': 'ठेगाना सेभ गर्न र खाना मगाउन साइन इन गर्नुहोस्।',
  'account.signIn': 'साइन इन',
  'account.addresses': 'सेभ गरिएका ठेगाना',
  'account.language': 'भाषा',
  'account.theme': 'रूप',
  'account.themeAuto': 'आफैं (राति १० बजेपछि डार्क)',
  'account.themeLight': 'लाइट',
  'account.themeDark': 'डार्क',
  'account.signOut': 'साइन आउट',
  'account.version': 'Capsico {version}',

  'home.searchPlaceholder': '"मोमो" वा रेस्टुरेन्ट खोज्नुहोस्',
  'home.promiseTitle1': 'प्लेटफर्म शुल्क शून्य',
  'home.promiseBody1': 'तपाईं खाना र डेलिभरी मात्र तिर्नुहुन्छ। केही लुकेको छैन।',
  'home.promiseTitle2': 'मेनुको मूल्य = एपको मूल्य',
  'home.promiseBody2': 'काउन्टरकै मूल्य। हरेक हप्ता जाँच गरिन्छ।',
  'home.promiseTitle3': 'तपाईंको सहर, तपाईंका भान्सा',
  'home.promiseBody3': 'स्थानीय मनपर्ने, स्थानीय राइडरबाट।',
  'home.cuisines': 'खानाका प्रकार',
  'home.mind': 'आज के खाने मन छ?',
  'home.top': 'तपाईं नजिकका उत्कृष्ट रेस्टुरेन्ट',
  'home.emptyTitle': 'भान्सा तात्दैछ 🔥',
  'home.emptyBody': 'अहिले यहाँ कुनै रेस्टुरेन्टले अर्डर लिइरहेको छैन। छिट्टै हेर्नुहोस्।',
  'home.closed': 'बन्द',
  'home.newBadge': 'नयाँ',
  'home.legend': 'लोकल लेजेन्ड',
  'home.forTwo': 'दुई जनाका लागि {amount}',
  'home.places': '{count} ठाउँ',

  'search.placeholder': 'परिकार वा रेस्टुरेन्ट खोज्नुहोस्',
  'search.sort': 'क्रम',
  'search.filterVeg': 'शाकाहारी',
  'search.filterPureVeg': 'शुद्ध शाकाहारी',
  'search.filterRating': 'रेटिङ ४+',
  'search.filterFast': 'छिटो डेलिभरी',
  'search.filterNew': 'नयाँ',
  'search.filterOpen': 'अहिले खुला',
  'search.results': '{count} रेस्टुरेन्ट',
  'search.noneTitle': 'केही भेटिएन',
  'search.noneBody': 'अर्को परिकारको नाम खोज्नुहोस्, वा फिल्टर हटाउनुहोस्।',
  'search.clear': 'फिल्टर हटाउनुहोस्',
  'search.matched': 'यसमा छ {dishes}',
  'search.start': 'परिकार, खानाको प्रकार वा रेस्टुरेन्ट खोज्नुहोस्',

  'restaurant.licence': '{kind} इजाजतपत्र {number}',
  'restaurant.vegOnly': 'शाकाहारी मात्र',
  'restaurant.searchMenu': 'मेनुमा खोज्नुहोस्',
  'restaurant.bestseller': 'बेस्टसेलर',
  'restaurant.customisable': 'आफ्नो अनुसार',
  'restaurant.add': 'थप्नुहोस्',
  'restaurant.menuEmpty': 'मेनु अपडेट हुँदैछ। छिट्टै हेर्नुहोस्।',
  'restaurant.noMatch': '"{query}" सँग मिल्ने परिकार भेटिएन',
  'restaurant.closed': 'अहिले बन्द छ',
  'restaurant.notFound': 'यो रेस्टुरेन्ट उपलब्ध छैन',
  'restaurant.items': '{count} परिकार',

  'customise.size': 'साइज छान्नुहोस्',
  'customise.required': 'अनिवार्य',
  'customise.optional': 'ऐच्छिक',
  'customise.upTo': '{max} सम्म छान्नुहोस्',
  'customise.exactly': '{count} छान्नुहोस्',
  'customise.between': '{min} देखि {max} छान्नुहोस्',
  'customise.pick': '{count} छान्नुहोस्',
  'customise.total': 'परिकारको जम्मा',
  'customise.addToCart': 'परिकार थप्नुहोस् · {price}',
  'customise.cartSoon': 'अर्डर छिट्टै सुरु — कार्ट अर्को अपडेटमा आउँदैछ 🙌',
  'customise.incomplete': 'अनिवार्य छनोट पूरा गर्नुहोस्',
  'cart.items': '{count} वटा',
  'cart.item': '1 वटा',
  'cart.view': 'कार्ट हेर्नुहोस्',
  'cart.added': 'कार्टमा थपियो 🛒',
  'cart.full': 'कार्ट भरियो — बढीमा 30 फरक परिकार',
  'cart.replaceTitle': 'नयाँ कार्ट सुरु गर्ने?',
  'cart.replaceBody':
    'तपाईंको कार्टमा {name} का परिकार छन्। यो रेस्टुरेन्टबाट नयाँ कार्ट सुरु गर्ने?',
  'cart.replaceYes': 'नयाँ कार्ट',
  'cart.replaceNo': 'पुरानै राख्ने',
  'cart.empty': 'तपाईंको कार्ट खाली छ',
  'cart.emptyHint': 'नजिकको रेस्टुरेन्टबाट केही मीठो रोज्नुहोस् 😋',
  'cart.browse': 'खाना खोज्नुहोस्',
  'checkout.title': 'चेकआउट',
  'checkout.addMore': 'थप परिकार थप्नुहोस्',
  'checkout.kitchenNote': 'रेस्टुरेन्टलाई नोट',
  'checkout.kitchenNoteHint': 'जस्तै कम पिरो, प्याज नहाल्ने',
  'checkout.cutlery': 'चम्चा पठाउनुहोस्',
  'checkout.cutleryHint': 'सामान्यतया बन्द — पृथ्वीका लागि राम्रो 🌱',
  'checkout.offers': 'अफर र कुपन',
  'checkout.viewOffers': 'सबै अफर हेर्नुहोस्',
  'checkout.applied': '{code} लागू भयो',
  'checkout.youSave': 'तपाईंको बचत {amount}',
  'checkout.remove': 'हटाउनुहोस्',
  'checkout.apply': 'लागू गर्नुहोस्',
  'checkout.enterCode': 'कुपन कोड लेख्नुहोस्',
  'checkout.funding.restaurant': 'रेस्टुरेन्टको अफर',
  'checkout.funding.capsico': 'Capsico को अफर',
  'checkout.funding.shared': 'रेस्टुरेन्ट + Capsico को अफर',
  'checkout.bill': 'बिल विवरण',
  'checkout.toPay': 'तिर्नुपर्ने',
  'checkout.savedTotal': 'यो अर्डरमा {amount} बचत 🎉',
  'checkout.why': 'यो शुल्क किन?',
  'checkout.gotIt': 'बुझें',
  'checkout.tip': 'राइडरलाई टिप दिनुहोस्',
  'checkout.tipHint': 'टिपको पूरै रकम राइडरलाई जान्छ',
  'checkout.noTip': 'टिप छैन',
  'checkout.deliverTo': 'डेलिभरी ठेगाना',
  'checkout.change': 'बदल्नुहोस्',
  'checkout.pickAddress': 'डेलिभरी ठेगाना छान्नुहोस्',
  'checkout.addAddress': 'नयाँ ठेगाना थप्नुहोस्',
  'checkout.needAddress': 'अर्डरका लागि ठेगाना थप्नुहोस्',
  'checkout.someoneElse': 'अरू कसैका लागि अर्डर?',
  'checkout.receiverName': 'बुझ्ने व्यक्तिको नाम',
  'checkout.receiverPhone': 'बुझ्ने व्यक्तिको फोन',
  'checkout.phoneError': 'सही फोन नम्बर लेख्नुहोस्',
  'checkout.when': 'कहिले',
  'checkout.now': 'अहिले',
  'checkout.prepaidOnly': 'तालिका अर्डर अनलाइन तिर्नुपर्छ',
  'checkout.payment': 'भुक्तानी',
  'checkout.cod': 'डेलिभरीमा नगद',
  'checkout.test': 'टेस्ट भुक्तानी (विकास मात्र)',
  'checkout.place': 'अर्डर गर्नुहोस्',
  'checkout.placing': 'अर्डर हुँदैछ…',
  'checkout.signIn': 'अर्डर गर्न साइन इन गर्नुहोस्',
  'checkout.pricesChanged': 'मूल्य बदलियो — बिल हेरेर फेरि अर्डर गर्नुहोस्',
  'checkout.placed': 'अर्डर भयो! 🎉',
  'checkout.freeDelivery': 'यो अर्डरमा निःशुल्क डेलिभरी 🎉',
  'checkout.freeLeft': 'यसपछि अझै {count} निःशुल्क डेलिभरी अर्डर',
  'checkout.minimum': 'अर्डर गर्न अझै {amount} थप्नुहोस्',
  'checkout.unavailable': 'बिल खुल्न सकेन',
  'orders.title': 'तपाईंका अर्डर',
  'orders.empty': 'अहिलेसम्म अर्डर छैन',
  'orders.emptyHint': 'पहिलो अर्डर एक ट्याप टाढा 🍛',
  'orders.placedTitle': 'अर्डर भयो! 🎉',
  'orders.placedBody': '{name} ले तपाईंको अर्डर पायो',
  'orders.number': 'अर्डर #{number}',
  'orders.eta': '{eta} मा आइपुग्छ',
  'orders.scheduledFor': '{time} का लागि तालिका',
  'orders.trackSoon': 'लाइभ ट्र्याकिङ अर्को अपडेटमा',
  'orders.backHome': 'गृहपृष्ठमा जानुहोस्',
  'orders.payCash': 'ढोकामा {amount} नगद तिर्नुहोस्',
  'orders.paid': 'भुक्तानी भयो',
  'orders.refunded': 'फिर्ता भयो',
  'orders.items': 'परिकार',
  'orders.deliveringTo': 'डेलिभरी',
  'orders.cancelledBecause': 'रद्द: {reason}',
  'orders.notFound': 'अर्डर भेटिएन',
  'stage.scheduled': 'तालिकामा',
  'stage.placed': 'रेस्टुरेन्टको पुष्टि बाँकी',
  'stage.preparing': 'पकाउँदै 🍳',
  'stage.ready': 'लैजान तयार',
  'stage.on_the_way': 'बाटोमा 🛵',
  'stage.delivered': 'पुग्यो',
  'stage.cancelled': 'रद्द',
  'account.orders': 'तपाईंका अर्डर',
  'common.today': 'आज',
  'common.tomorrow': 'भोलि',
  'stage.awaiting_payment': 'भुक्तानी बाँकी',
  'account.wallet': 'Capsico Money',
  'pay.wallet': 'Capsico Money',
  'pay.walletUsing': 'यो अर्डरमा {amount} प्रयोग हुनेछ',
  'pay.walletOff': 'ब्यालेन्स प्रयोग गर्न खोल्नुहोस्',
  'pay.walletExpires': '{amount} को म्याद {date} मा सकिन्छ',
  'pay.walletApplied': '{amount} Capsico Money लागू भयो',
  'pay.payAmount': '{amount} तिर्नुहोस्',
  'pay.payWallet': 'Capsico Money बाट तिर्नुहोस्',
  'pay.secure': '100% सुरक्षित भुक्तानी',
  'pay.method.cod': 'डेलिभरीमा नगद',
  'pay.method.test': 'टेस्ट भुक्तानी (विकास मात्र)',
  'pay.method.wallet': 'Capsico Money',
  'pay.method.upi': 'UPI',
  'pay.method.card': 'क्रेडिट / डेबिट कार्ड',
  'pay.method.netbanking': 'नेटबैंकिङ',
  'pay.method.esewa': 'eSewa',
  'pay.method.khalti': 'Khalti',
  'pay.method.fonepay': 'Fonepay QR',
  'pay.method.imepay': 'IME Pay',
  'pay.method.connectips': 'ConnectIPS',
  'payment.paid': 'भुक्तानी प्राप्त भयो 🎉',
  'payment.notFinished': 'भुक्तानी पूरा भएन। यहीँबाट फेरि तिर्न सक्नुहुन्छ।',
  'payment.notYet': 'अझै आइपुगेको छैन — केही सेकेन्ड पर्खनुहोस्।',
  'payment.failed': 'भुक्तानी हुन सकेन',
  'payment.cancelled': 'अर्डर रद्द भयो',
  'payment.qrCopied': 'कोड कपी भयो',
  'payment.gatewayDown': 'भुक्तानी पेज खुलेन। इन्टरनेट जाँचेर फेरि प्रयास गर्नुहोस्।',
  'payment.waitingTitle': 'भुक्तानी पूरा गर्नुहोस्',
  'payment.waitingBody': '{amount} तिर्नुहोस् — पैसा आउनेबित्तिकै रेस्टुरेन्टले पकाउन थाल्छ।',
  'payment.payNow': 'अहिले तिर्नुहोस्',
  'payment.payAnother': 'अर्को तरिकाले तिर्नुहोस्',
  'payment.cancelOrder': 'अर्डर रद्द गर्नुहोस्',
  'payment.keepOrder': 'अर्डर राख्नुहोस्',
  'payment.cancelTitle': 'यो अर्डर रद्द गर्ने?',
  'payment.cancelBody':
    'कुनै पैसा काटिएको भए फिर्ता आउँछ। यो अर्डरमा प्रयोग भएको Capsico Money ब्यालेन्समा फर्किन्छ।',
  'payment.pickMethod': 'भुक्तानीको तरिका छान्नुहोस्',
  'payment.qrTitle': '{amount} तिर्न स्क्यान गर्नुहोस्',
  'payment.qrBody':
    'आफ्नो बैंक वा वालेट एप खोलेर यो Fonepay कोड स्क्यान वा पेस्ट गरी तिर्नुहोस्। भुक्तानी हामी आफैँ थाहा पाउँछौँ।',
  'payment.qrCopy': 'कोड कपी गर्नुहोस्',
  'payment.qrWaiting': 'तपाईंको भुक्तानी पर्खँदै…',
  'payment.qrPaid': 'मैले तिरेँ',
  'payment.partlyRefunded': '{amount} फिर्ता भयो',
  'payment.failedStatus': 'भुक्तानी हुन सकेन',
  'payment.walletUsed': '{amount} Capsico Money बाट तिरियो',
  'payment.returnTitle': 'भुक्तानी',
  'payment.confirming': 'तपाईंको भुक्तानी पुष्टि गर्दै…',
  'payment.confirmingBody': 'पर्खनुहोस् — {gateway} सँग जाँच गर्दैछौँ। एप बन्द नगर्नुहोस्।',
  'payment.slow': 'सामान्यभन्दा बढी समय लाग्दैछ। अर्डर पेज आफैँ अपडेट हुन्छ।',
  'payment.viewOrder': 'अर्डर हेर्नुहोस्',
  'payment.failedBody':
    'खाताबाट पैसा गएको भए आफैँ फिर्ता आउँछ। फेरि प्रयास गर्नुहोस् वा अर्को तरिका छान्नुहोस्।',
  'payment.tryAgain': 'फेरि प्रयास गर्नुहोस्',
  'payment.returnBroken': 'यो भुक्तानी पढ्न सकिएन',
  'payment.returnBrokenBody': "स्थिति हेर्न 'तपाईंका अर्डर' बाट अर्डर खोल्नुहोस्।",
  'refund.title': 'फिर्ता',
  'refund.toWallet': 'Capsico Money मा',
  'refund.toSource': 'तपाईंको मूल भुक्तानी तरिकामा',
  'refund.status.awaiting_choice': 'कहाँ पठाउने छान्नुहोस्',
  'refund.status.processing': 'प्रक्रियामा · ३–५ दिन',
  'refund.status.manual': 'प्रक्रियामा · ३–५ दिन',
  'refund.status.done': 'फिर्ता भयो',
  'refund.status.failed': 'ढिलाइ — सपोर्टले सम्पर्क गर्नेछ',
  'refund.choiceTitle': '{amount} कहाँ पठाउने?',
  'refund.choiceWallet': 'अहिले Capsico Money मा',
  'refund.choiceWalletBonus': 'अहिले Capsico Money मा (+{amount} बोनस)',
  'refund.choiceWalletHint': 'तुरुन्तै — अर्को अर्डरमा प्रयोग गर्नुहोस्',
  'refund.choiceSource': 'मूल तरिकामा फिर्ता',
  'refund.choiceSourceHint': '३–५ दिन लाग्छ',
  'refund.chooseBy': '{time} सम्म छान्नुहोस्, नत्र Capsico Money मा जान्छ',
  'refund.saved': 'भयो — फिर्ता आउँदैछ',
  'refund.reason.restaurant_rejected': 'रेस्टुरेन्टले अर्डर लिन सकेन',
  'refund.reason.not_accepted': 'रेस्टुरेन्टले समयमै अर्डर लिएन',
  'refund.reason.ops_cancelled': 'Capsico ले रद्द गर्‍यो',
  'refund.reason.customer_cancelled': 'तपाईंले अर्डर रद्द गर्नुभयो',
  'refund.reason.payment_timeout': 'भुक्तानी समयमै पूरा भएन',
  'refund.reason.complaint': 'गुनासो स्वीकृत',
  'refund.reason.goodwill': 'Capsico को तर्फबाट क्रेडिट',
  'invoice.title': 'कर बिजक',
  'invoice.food': 'खानाको बिल',
  'invoice.fees': 'Capsico शुल्कको बिल',
  'invoice.download': 'डाउनलोड',
  'invoice.failed': 'बिल डाउनलोड भएन। फेरि प्रयास गर्नुहोस्।',
  'wallet.title': 'Capsico Money',
  'wallet.balance': 'Capsico Money ब्यालेन्स',
  'wallet.heroHint': 'जुनसुकै अर्डरमा प्रयोग गर्नुहोस् — चेकआउटमा लाग्छ',
  'wallet.storeCredit': 'स्टोर क्रेडिट मात्र — टप-अप हुँदैन। हरेक क्रेडिटको म्याद हुन्छ।',
  'wallet.credits': 'तपाईंका क्रेडिट',
  'wallet.expiresOn': '{date} मा सकिन्छ',
  'wallet.left': '{total} मध्ये {left} बाँकी',
  'wallet.source.refund': 'फिर्ता',
  'wallet.source.complaint_bonus': 'Capsico Money छानेको बोनस',
  'wallet.source.goodwill': 'Capsico को तर्फबाट',
  'wallet.source.compensation': 'माफी क्रेडिट',
  'wallet.source.referral': 'साथी बोलाएको पुरस्कार',
  'wallet.source.cashback': 'क्यासब्याक',
  'wallet.source.winback': 'फिर्ती क्रेडिट',
  'wallet.history': 'इतिहास',
  'wallet.entry.credit': 'थपियो',
  'wallet.entry.debit': 'अर्डरमा प्रयोग',
  'wallet.entry.reverse': 'फिर्ता आयो',
  'wallet.entry.expire': 'म्याद सकियो',
  'wallet.empty': 'अहिलेसम्म Capsico Money छैन',
  'wallet.emptyHint': 'फिर्ता र Capsico का क्रेडिट यहाँ देखिन्छन्।',
  'wallet.pending': 'तपाईंको छनोट पर्खिरहेका फिर्ता',
  'wallet.noHistory': 'अहिलेसम्म केही छैन',
  'wallet.country.IN': 'भारत ₹',
  'wallet.country.NP': 'नेपाल Rs',
  'checkout.leaveAtDoor': 'ढोकामा छोडिदिनुहोस्',
  'checkout.leaveAtDoorHint': 'न घण्टी, न कोड — राइडरले छोडेर तपाईंलाई फोटो पठाउनुहुन्छ 📸',
  'track.stage.placed': 'अर्डर भयो',
  'track.stage.accepted': 'रेस्टुरेन्टले अर्डर लियो',
  'track.stage.preparing': 'तपाईंको खाना पाक्दैछ 🍳',
  'track.stage.ready': 'खाना तयार छ',
  'track.stage.rider_assigned': 'राइडर रेस्टुरेन्टतर्फ जाँदै हुनुहुन्छ',
  'track.stage.picked_up': 'पिकअप भयो — बाटोमा 🛵',
  'track.stage.nearby': 'राइडर नजिकै हुनुहुन्छ',
  'track.stage.delivered': 'डेलिभर भयो 🎉',
  'track.stage.cancelled': 'अर्डर रद्द भयो',
  'track.step.placed': 'अर्डर भयो',
  'track.step.accepted': 'स्वीकार',
  'track.step.preparing': 'पाक्दै',
  'track.step.ready': 'तयार',
  'track.step.rider_assigned': 'राइडर तोकियो',
  'track.step.picked_up': 'पिकअप',
  'track.step.nearby': 'नजिकै',
  'track.step.delivered': 'डेलिभर',
  'track.step.cancelled': 'रद्द',
  'track.sub.placed': '{name} को जवाफ पर्खँदै',
  'track.sub.accepted': '{name} सँग तपाईंको अर्डर छ',
  'track.sub.preparing': '{name} ताजा पकाउँदैछ',
  'track.sub.ready': 'प्याक भयो, राइडर पर्खँदै',
  'track.sub.findingRider': 'रेस्टुरेन्ट नजिक राइडर खोज्दैछौं…',
  'track.sub.rider_assigned': '{rider} रेस्टुरेन्टतर्फ जाँदै हुनुहुन्छ',
  'track.sub.picked_up': '{rider} तपाईंतर्फ आउँदै हुनुहुन्छ',
  'track.sub.nearby': '{rider} आइपुग्न लाग्नुभयो — फोन नजिकै राख्नुहोस्',
  'track.sub.delivered': 'खानाको मज्जा लिनुहोस्!',
  'track.etaArriving': 'आइपुग्छ',
  'track.etaRange': '{from}–{to} मिनेट',
  'track.etaMinutes': '{minutes} मिनेट',
  'track.late': 'अलि ढिलो',
  'track.lateBody': 'माफ गर्नुहोस्, भनेभन्दा बढी समय लाग्दैछ। हामी लागिरहेका छौं।',
  'track.lateApology': 'ढिलाइको लागि माफी 🙏 तपाईंको वालेटमा Capsico Money थपिएको छ।',
  'track.reconnecting': 'लाइभ अपडेट रोकिएको छ। हरेक 15 सेकेन्डमा ताजा गर्दैछौं…',
  'track.mapLabel': 'तपाईंको डेलिभरीको नक्सा',
  'track.pinRestaurant': 'रेस्टुरेन्ट',
  'track.pinHome': 'तपाईंको ठाउँ',
  'track.pinRider': 'तपाईंको राइडर',
  'track.recenter': 'नक्सामा सबै देखाउनुहोस्',
  'track.steps': 'अर्डरको प्रगति',
  'track.rider.call': 'राइडरलाई कल गर्नुहोस्',
  'track.rider.chat': 'राइडरसँग च्याट',
  'track.rider.unread': '{count} नयाँ सन्देश',
  'track.rider.masked': 'कल Capsico हुँदै जान्छ — तपाईंको नम्बर गोप्य रहन्छ।',
  'track.vehicle.walker': 'पैदल',
  'track.vehicle.cyclist': 'साइकल',
  'track.vehicle.motorbike': 'बाइक',
  'track.callUnavailable':
    'अहिले कल गर्न मिल्दैन। च्याट गर्नुहोस् वा Capsico सपोर्टलाई कल गर्नुहोस्।',
  'track.code.title': 'डेलिभरी कोड',
  'track.code.hint': 'यो कोड ढोकामै राइडरलाई मात्र भन्नुहोस्।',
  'track.code.locked': 'धेरै पटक गलत कोड हालियो। Capsico सपोर्टले राइडरलाई सघाउनेछ।',
  'track.code.failed': 'कोड लोड भएन।',
  'track.leaveAtDoor': 'ढोकामा छोड्ने — राइडरले राखेर फोटो पठाउनुहुन्छ।',
  'track.proof.title': 'ढोकामा राखियो',
  'track.proof.caption': 'राइडरले खिचेको फोटो। ३० दिनसम्म रहन्छ।',
  'chat.title': '{name} सँग च्याट',
  'chat.placeholder': 'सन्देश लेख्नुहोस्',
  'chat.send': 'पठाउनुहोस्',
  'chat.sending': 'पठाउँदै…',
  'chat.closed': 'अर्डर डेलिभर भएपछि च्याट बन्द हुन्छ।',
  'chat.empty': 'नमस्ते भन्नुहोस् वा छिटो जवाफ छान्नुहोस् 👋',
  'chat.failed': 'सन्देश गएन। फेरि प्रयास गर्नुहोस्।',
  'chat.quick.at_gate': 'म गेटमा छु',
  'chat.quick.please_call': 'कृपया कल गर्नुहोस्',
  'chat.quick.coming_down': 'तल आउँदैछु',
  'chat.quick.wait_two': 'कृपया २ मिनेट पर्खनुहोस्',
  'chat.quick.on_the_way': 'आउँदैछु',
  'chat.quick.reached': 'म आइपुगें',

  // W16 Help + chat
  'help.title': 'मद्दत र सहयोग',
  'help.orderHelp': 'यो अर्डरमा मद्दत',
  'help.myTickets': 'तपाईंका च्याट',
  'help.noTickets': 'अहिलेसम्म कुनै च्याट छैन',
  'help.noTicketsBody': 'केही गडबड छ? च्याट सुरु गर्नुहोस् — हामी प्रायः केही मिनेटमै मिलाउँछौं।',
  'help.recentOrders': 'हालको अर्डरमा मद्दत',
  'help.otherTopics': 'अरू केही',
  'help.otherBody': 'खाता, भुक्तानी वा कुनै एक अर्डरसँग नजोडिएको कुरा',
  'help.deskOpen': 'हाम्रो टिम अनलाइन छ',
  'help.deskClosed': 'हाम्रो टिम अहिले अफलाइन छ',
  'help.botNote': 'हाम्रो सहायकले राति पनि तुरुन्तै जवाफ दिन्छ। {hours}',
  'help.loadFailed': 'मद्दत लोड भएन',
  'help.newTitle': 'के गडबड भयो?',
  'help.newTitleOrder': 'अर्डर {number} मा मद्दत',
  'help.reasonLabel': 'कारण छान्नुहोस्',
  'help.openExisting': 'यसबारे तपाईंको च्याट पहिल्यै खुला छ',
  'help.openChat': 'च्याट खोल्नुहोस्',
  'help.items': 'कुन सामानहरू?',
  'help.itemsHint': 'नआएको वा गलत आएको छान्नुहोस्',
  'help.itemOf': '{ordered} मध्ये {picked}',
  'help.less': 'एक कम',
  'help.more': 'एक थप',
  'help.photos': 'फोटो थप्नुहोस्',
  'help.photosHint': 'सफा फोटोले छिटो मिलाउन मद्दत गर्छ ({max} सम्म)',
  'help.addPhoto': 'फोटो थप्नुहोस्',
  'help.removePhoto': 'फोटो हटाउनुहोस्',
  'help.photoFailed': 'भएन',
  'help.photoType': 'JPG, PNG वा WebP फोटो राख्नुहोस्',
  'help.photoSize': 'फोटो धेरै ठूलो छ (बढीमा 8 MB)',
  'help.photoMany': 'तपाईं {max} वटा फोटोसम्म थप्न सक्नुहुन्छ',
  'help.photoUpload': 'फोटो अपलोड भएन। फेरि प्रयास गर्नुहोस्।',
  'help.note': 'अरू केही? (ऐच्छिक)',
  'help.notePlaceholder': 'के भयो भन्नुहोस्',
  'help.needItems': 'कम्तीमा एउटा सामान छान्नुहोस्',
  'help.needPhoto': 'अगाडि बढ्न फोटो थप्नुहोस्',
  'help.uploading': 'फोटो अपलोड हुन दिनुहोस्',
  'help.submit': 'च्याट सुरु गर्नुहोस्',
  'help.createFailed': 'च्याट खुल्न सकेन। फेरि प्रयास गर्नुहोस्।',
  'help.group.order': 'खाना र सामान',
  'help.group.delivery': 'डेलिभरी',
  'help.group.payment': 'भुक्तानी र फिर्ता',
  'help.group.conduct': 'व्यवहार',
  'help.group.partner': 'रेस्टुरेन्ट साझेदार',
  'help.group.rider': 'राइडर',
  'help.group.other': 'अन्य',
  'help.status.bot': 'सहायकसँग',
  'help.status.queued': 'एजेन्टको पर्खाइ',
  'help.status.assigned': 'एजेन्ट जवाफ दिँदै',
  'help.status.waiting_customer': 'तपाईंको पर्खाइ',
  'help.status.resolved': 'समाधान भयो',
  'help.status.closed': 'बन्द',
  'help.chatTitle': 'च्याट {number}',
  'help.orderLabel': 'अर्डर {number}',
  'help.bot': 'Capsico सहायक',
  'help.agent': 'Capsico सहयोग',
  'help.team': 'Capsico',
  'help.empty': 'के भयो भन्नुहोस्, बाँकी हामी हेर्छौं।',
  'help.placeholder': 'सन्देश लेख्नुहोस्',
  'help.send': 'पठाउनुहोस्',
  'help.attach': 'फोटो थप्नुहोस्',
  'help.sending': 'पठाउँदै…',
  'help.sendFailed': 'सन्देश गएन। फेरि प्रयास गर्नुहोस्।',
  'help.actionFailed': 'त्यो भएन। फेरि प्रयास गर्नुहोस्।',
  'help.talkToAgent': 'एजेन्टसँग कुरा गर्नुहोस्',
  'help.agentAsked': 'भयो — एजेन्ट छिट्टै जोडिनुहुनेछ',
  'help.queue': 'तपाईं लाइनमा #{n} मा हुनुहुन्छ',
  'help.agentReplying': 'Capsico बाट {name} ले मद्दत गर्दै हुनुहुन्छ',
  'help.language': 'च्याटको भाषा',
  'help.reconnecting': 'फेरि जोड्दै… हरेक 15 सेकेन्डमा अपडेट',
  'help.closedNotice': 'यो च्याट बन्द भयो। अझै मद्दत चाहिए नयाँ च्याट सुरु गर्नुहोस्।',
  'help.refunds': 'यो च्याटका फिर्ता',
  'help.rateTitle': 'हामीले कस्तो गर्‍यौं?',
  'help.rateBody': 'यो च्याटलाई मूल्याङ्कन गर्नुहोस् — यसले हामीलाई सुधार्न मद्दत गर्छ।',
  'help.star': '5 मध्ये {n}',
  'help.rateComment': 'केही थप्नु छ? (ऐच्छिक)',
  'help.rateSubmit': 'मूल्याङ्कन पठाउनुहोस्',
  'help.rated': 'मूल्याङ्कनका लागि धन्यवाद!',
  'help.ratedLine': 'तपाईंले यो च्याटलाई {score} / 5 दिनुभयो',
  'help.notFound': 'च्याट भेटिएन',
  'help.callAsked': 'कल अनुरोध भयो — हामी छिट्टै फोन गर्छौं',
  'help.requestCall': 'कल अनुरोध गर्नुहोस्',
  'help.callRequested': '{time} मा कल अनुरोध गरियो',
  'help.unread': 'नयाँ जवाफ',
  'rate.title': 'आफ्नो अर्डर रेट गर्नुहोस्',
  'rate.from': '{name} बाट',
  'rate.editTitle': 'आफ्नो रेटिङ बदल्नुहोस्',
  'rate.food': 'खाना कस्तो थियो?',
  'rate.delivery': 'डेलिभरी कस्तो थियो?',
  'rate.star1': 'धेरै नराम्रो',
  'rate.star2': 'नराम्रो',
  'rate.star3': 'ठिकै',
  'rate.star4': 'राम्रो',
  'rate.star5': 'धेरै मन पर्यो',
  'rate.starAria': '5 मध्ये {n}',
  'rate.dishes': 'कुन परिकार मन पर्यो?',
  'rate.like': '{name} मन पर्यो',
  'rate.unlike': '{name} मन परेन',
  'rate.text': 'अरूलाई भन्नुहोस् (ऐच्छिक)',
  'rate.textPlaceholder': 'के मन पर्यो? के अझ राम्रो हुन सक्थ्यो?',
  'rate.count': '{n}/{max}',
  'rate.photos': 'फोटो थप्नुहोस्',
  'rate.photosHint': 'आफ्नो खानाका ३ वटासम्म फोटो',
  'rate.addPhoto': 'फोटो थप्नुहोस्',
  'rate.removePhoto': 'फोटो हटाउनुहोस्',
  'rate.uploading': 'अपलोड हुँदैछ {percent}%',
  'rate.photoFailed': 'अपलोड भएन',
  'rate.submit': 'रेटिङ पठाउनुहोस्',
  'rate.save': 'परिवर्तन सेभ गर्नुहोस्',
  'rate.editUntil': 'तपाईं यसलाई {time} सम्म बदल्न सक्नुहुन्छ',
  'rate.thanks': 'रेटिङको लागि धन्यवाद! 🙌',
  'rate.updated': 'रेटिङ अपडेट भयो',
  'rate.changed': 'यो रेटिङ अर्को ठाउँमा बदलियो। हामीले फेरि लोड गर्यौं।',
  'rate.failed': 'तपाईंको रेटिङ गएन। फेरि प्रयास गर्नुहोस्।',
  'rate.badType': 'JPG, PNG वा WebP फोटो राख्नुहोस्',
  'rate.tooBig': 'फोटो धेरै ठूलो छ (बढीमा 8 MB)',
  'rate.tooMany': 'तपाईं ३ वटासम्म फोटो थप्न सक्नुहुन्छ',
  'rate.uploadFailed': 'एउटा फोटो अपलोड भएन। हटाएर फेरि प्रयास गर्नुहोस्।',
  'rate.blockTitle': 'हामी यो रेटिङ लिन सक्दैनौं',
  'rate.block.not_delivered': 'अर्डर डेलिभर भएपछि मात्र रेट गर्न सकिन्छ।',
  'rate.block.window_closed': 'यो अर्डर रेट गर्ने समय सकियो।',
  'rate.block.already_reviewed':
    'तपाईंले यो अर्डर पहिल्यै रेट गर्नुभयो — My reviews बाट बदल्न सक्नुहुन्छ।',
  'rate.block.self_review': 'रेस्टुरेन्टकै टोली वा फोनबाट रेटिङ गर्न पाइँदैन।',
  'rate.block.self_order': 'यो अर्डर रेट गर्न मिल्दैन।',
  'rate.block.not_yours': 'यो अर्डर अर्को खाताको हो।',
  'rate.cardTitle': 'तपाईंको अर्डर कस्तो थियो?',
  'rate.cardBody': '{name} लाई रेट गर्नुहोस् — १० सेकेन्ड मात्र',
  'rate.cardAction': 'अहिले रेट गर्नुहोस्',
  'rate.rateBy': '{time} सम्म रेट गर्नुहोस्',
  'rate.yours': 'तपाईंको रेटिङ',
  'rate.foodShort': 'खाना',
  'rate.deliveryShort': 'डेलिभरी',
  'rate.stripTitle': 'आफ्ना अर्डर रेट गर्नुहोस्',
  'rate.stripOne': '{name} कस्तो थियो?',
  'rate.stripMany': '{name} र अरू {count}',
  'rate.stripAction': 'रेट',
  'reviews.title': 'रेटिङ र रिभ्यु',
  'reviews.new': 'नयाँ',
  'reviews.newBody': 'अझै पर्याप्त रेटिङ छैन — पहिलो हुनुहोस्',
  'reviews.count': '{count} रेटिङ · पछिल्लो ९० दिन',
  'reviews.seeAll': 'सबै रिभ्यु हेर्नुहोस्',
  'reviews.empty': 'अझै रिभ्यु छैन',
  'reviews.emptyBody': 'अर्डर गर्नुहोस् र पहिलो रिभ्यु लेख्नुहोस् 🍛',
  'reviews.sort': 'रिभ्यु क्रम',
  'reviews.sort.recent': 'नयाँ',
  'reviews.sort.highest': 'उच्च',
  'reviews.sort.lowest': 'न्यून',
  'reviews.sort.photos': 'फोटो सहित',
  'reviews.reply': 'रेस्टुरेन्टको जवाफ',
  'reviews.liked': 'मन परेको: {dishes}',
  'reviews.hygiene.green': 'सरसफाइ: धेरै राम्रो',
  'reviews.hygiene.amber': 'सरसफाइ: राम्रो',
  'reviews.loadMore': 'थप हेर्नुहोस्',
  'reviews.photo': 'रिभ्यु फोटो',
  'reviews.stars': '{n} तारा',
  'reviews.end': 'यति नै रिभ्यु',
  'my.title': 'मेरा रिभ्यु',
  'my.toRate': 'तपाईंको रेटिङ पर्खिँदै',
  'my.yours': 'तपाईंका रिभ्यु',
  'my.empty': 'अझै रिभ्यु छैन',
  'my.emptyBody': 'डेलिभर भएको अर्डर रेट गरेपछि तपाईंको रेटिङ यहाँ देखिन्छ।',
  'my.status.held': 'जाँचमा — अझै देखिँदैन',
  'my.status.hidden': 'Capsico ले टेक्स्ट लुकायो — तपाईंका तारा गनिन्छन्',
  'my.status.removed': 'रेटिङबाट हटाइयो',
  'my.order': 'अर्डर #{number}',
  'account.reviews': 'मेरा रिभ्यु',
  'restaurant.likes': '{count} लाई मन पर्यो',
  /* W18: notifications + growth */
  'nav.inbox': 'सूचनाहरू',
  'inbox.title': 'सूचनाहरू',
  'inbox.bell': 'सूचनाहरू',
  'inbox.bellUnread': 'सूचनाहरू, {count} नयाँ',
  'inbox.unreadCount': '{count} नयाँ',
  'inbox.readAll': 'सबै पढिसकेको बनाउनुहोस्',
  'inbox.empty': 'अहिलेसम्म कुनै सूचना छैन',
  'inbox.emptyBody': 'अर्डर अपडेट, अफर र सपोर्टका जवाफ यहाँ आउँछन्।',
  'inbox.loadMore': 'थप हेर्नुहोस्',
  'inbox.end': 'सबै हेरिसक्नुभयो ✨',
  'inbox.settings': 'सूचना सेटिङ',
  'inbox.signIn': 'आफ्ना सूचनाहरू हेर्न साइन इन गर्नुहोस्',
  'inbox.failed': 'अपडेट भएन। फेरि प्रयास गर्नुहोस्।',
  'inbox.new': 'नयाँ',
  'notify.cat.orders': 'अर्डर',
  'notify.cat.support': 'मद्दत र सपोर्ट',
  'notify.cat.account': 'खाता र पैसा',
  'notify.cat.offers': 'अफर र डिल',
  'notify.cat.reminders': 'रिमाइन्डर',
  'prefs.title': 'सूचना सेटिङ',
  'prefs.categories': 'हामी तपाईंलाई केबारे जानकारी दिन्छौं',
  'prefs.ordersHint': 'अर्डर अपडेट, डेलिभरी कोड, रिफन्ड र सपोर्टका जवाफ',
  'prefs.ordersLocked': 'सधैं चालु — खाना पाउन यी आवश्यक छन्',
  'prefs.offersHint': 'डिल, नयाँ रेस्टुरेन्ट र नयाँ अफर',
  'prefs.remindersHint': 'कार्टमा छुटेको सामान, अर्डर रेट गर्नुहोस्',
  'prefs.channels': 'अफर र रिमाइन्डर कहाँ पठाउने',
  'prefs.channelsHint': 'अर्डर, सपोर्ट र खाताका सन्देश सधैं तपाईंसम्म पुग्छन्।',
  'prefs.push': 'पुस सूचना',
  'prefs.sms': 'SMS',
  'prefs.whatsapp': 'WhatsApp',
  'prefs.saved': 'सूचना सेटिङ सेभ भयो',
  'prefs.failed': 'सेभ भएन। फेरि प्रयास गर्नुहोस्।',
  'prefs.quiet': 'हामी राति १० बजेदेखि बिहान ११ बजेसम्म अफर पठाउँदैनौं, र हप्तामा बढीमा ३ वटा।',
  'account.notifications': 'सूचनाहरू',
  'account.refer': 'रेफर गर्नुहोस् र कमाउनुहोस्',
  'account.campus': 'क्याम्पस पास',
  'refer.title': 'रेफर गर्नुहोस् र कमाउनुहोस्',
  'refer.hero': 'साथीहरूलाई बोलाउनुहोस्, हरेकमा {amount} कमाउनुहोस् 🎉',
  'refer.heroBody':
    'तपाईंको साथीले पहिलो अर्डरमा {offer} पाउनुहुन्छ। डेलिभर भएपछि तपाईंले {amount} Capsico Money पाउनुहुन्छ।',
  'refer.heroBodyNoOffer':
    'साथीको पहिलो अर्डर डेलिभर भएपछि तपाईंले {amount} Capsico Money पाउनुहुन्छ।',
  'refer.yourCode': 'तपाईंको कोड',
  'refer.copy': 'कपी',
  'refer.copied': 'कोड कपी भयो',
  'refer.linkCopied': 'निमन्त्रणा कपी भयो — जहाँ पनि पेस्ट गर्नुहोस्',
  'refer.share': 'निमन्त्रणा सेयर गर्नुहोस्',
  'refer.shareTitle': 'Capsico मा अर्डर गर्नुहोस्',
  'refer.friendsJoined': 'जोडिएका साथी',
  'refer.waiting': 'पर्खाइमा',
  'refer.earned': 'कमाइ',
  'refer.monthCap': 'यो महिना {cap} मध्ये {used} रिवार्ड प्रयोग भयो',
  'refer.history': 'तपाईंका निमन्त्रणा',
  'refer.noHistory': 'अहिलेसम्म कुनै निमन्त्रणा छैन। सुरु गर्न आफ्नो कोड सेयर गर्नुहोस्।',
  'refer.status.pending': 'पहिलो डेलिभरीको पर्खाइ',
  'refer.status.rewarded': 'रिवार्ड पाइयो',
  'refer.status.blocked': 'रिवार्ड पाइएन',
  'refer.status.expired': 'म्याद सकियो',
  'refer.rules': 'यसले कसरी काम गर्छ',
  'refer.rule1': 'Capsico मा कहिल्यै अर्डर नगरेका साथीहरूसँग आफ्नो कोड वा लिङ्क सेयर गर्नुहोस्।',
  'refer.rule2': 'तपाईंको साथीले पहिलो अर्डरमा स्वागत अफर पाउनुहुन्छ।',
  'refer.rule3':
    'उहाँको पहिलो अर्डर डेलिभर भएपछि तपाईंले {amount} Capsico Money पाउनुहुन्छ। यसको म्याद {days} दिनमा सकिन्छ।',
  'refer.rule4': 'महिनामा बढीमा {cap} रिवार्ड। तपाईंकै फोन, ठेगाना वा भुक्तानी खाता गनिँदैन।',
  'refer.haveCode': 'साथीको कोड छ?',
  'refer.codeLabel': 'साथी, एम्बासडर वा क्रिएटर कोड',
  'refer.apply': 'लगाउनुहोस्',
  'growth.codeApplied': 'कोड {code} लाग्यो 🎉',
  'growth.offerReady': 'अफर {code} चेकआउटमा तयार छ 🎁',
  'campus.title': 'क्याम्पस पास',
  'campus.hero': 'क्याम्पसमा निःशुल्क डेलिभरी 🎓',
  'campus.heroBody':
    '{days} दिनसम्म तपाईंको क्याम्पसको {km} km भित्र निःशुल्क डेलिभरी। विद्यार्थीका लागि मात्र।',
  'campus.pick': 'आफ्नो क्याम्पस छान्नुहोस्',
  'campus.distance': '{km} km टाढा',
  'campus.freeWithin': '{km} km भित्र निःशुल्क डेलिभरी',
  'campus.noCampus': 'तपाईं नजिक अहिलेसम्म कुनै क्याम्पस छैन',
  'campus.noCampusBody': 'क्याम्पस पास अहिले केही कलेजमा छ। हामी थप्दै छौं।',
  'campus.useLocation': 'मेरो नजिकका क्याम्पस खोज्नुहोस्',
  'campus.locating': 'तपाईंको स्थान खोज्दै…',
  'campus.how': 'तपाईं कसरी प्रमाणित गर्न चाहनुहुन्छ?',
  'campus.methodEmail': 'कलेज इमेल',
  'campus.methodEmailHint': 'हामी तपाईंको कलेज इमेलमा ६ अङ्कको कोड पठाउँछौं',
  'campus.methodPhoto': 'विद्यार्थी परिचयपत्रको फोटो',
  'campus.methodPhotoHint': 'हाम्रो टिमले जाँच गर्छ, प्रायः एक दिनभित्र',
  'campus.email': 'कलेज इमेल',
  'campus.emailHint': '{domains} मा अन्त्य हुनुपर्छ',
  'campus.emailBad': 'आफ्नो कलेज इमेल ठेगाना राख्नुहोस्',
  'campus.ambassador': 'एम्बासडर कोड (वैकल्पिक)',
  'campus.sendCode': 'कोड पठाउनुहोस्',
  'campus.continue': 'अगाडि बढ्नुहोस्',
  'campus.sent': 'कोड तपाईंको कलेज इमेलमा पठाइयो 📧',
  'campus.codeTitle': 'आफ्नो कलेज इमेल हेर्नुहोस्',
  'campus.codeBody': '{email} मा पठाइएको ६ अङ्कको कोड राख्नुहोस्।',
  'campus.code': '६ अङ्कको कोड',
  'campus.verify': 'प्रमाणित गर्नुहोस्',
  'campus.verified': 'क्याम्पस पास सक्रिय भयो 🎉',
  'campus.startOver': 'फेरि सुरु गर्नुहोस्',
  'campus.photoTitle': 'आफ्नो विद्यार्थी परिचयपत्र अपलोड गर्नुहोस्',
  'campus.photoBody': 'अगाडिको स्पष्ट फोटो, जसमा तपाईंको नाम र कलेज देखियोस्।',
  'campus.photoPick': 'फोटो थप्नुहोस्',
  'campus.photoReplace': 'बदल्नुहोस्',
  'campus.photoRemove': 'हटाउनुहोस्',
  'campus.photoUpload': 'जाँचका लागि पठाउनुहोस्',
  'campus.photoUploading': 'अपलोड हुँदै {percent}%',
  'campus.photoTooBig': 'फोटो ८ MB भन्दा सानो JPG, PNG वा WebP हुनुपर्छ',
  'campus.uploaded': 'परिचयपत्र पठाइयो — हामी छिट्टै जाँच गर्छौं',
  'campus.failed': 'केही गडबड भयो। फेरि प्रयास गर्नुहोस्।',
  'campus.status.pending_email': 'आफ्नो कलेज इमेल हेर्नुहोस्',
  'campus.status.pending_photo': 'आफ्नो परिचयपत्र अपलोड गर्नुहोस्',
  'campus.status.pending_review': 'जाँच हुँदैछ',
  'campus.status.active': 'सक्रिय',
  'campus.status.rejected': 'स्वीकृत भएन',
  'campus.status.expired': 'म्याद सकियो',
  'campus.activeBody': '{campus} को {km} km भित्र निःशुल्क डेलिभरी।',
  'campus.validUntil': '{date} सम्म मान्य',
  'campus.reviewBody': 'हामी {campus} का लागि तपाईंको परिचयपत्र जाँच्दै छौं। हामी जानकारी दिनेछौं।',
  'campus.rejectedBody': 'कारण: {reason}',
  'campus.tryAgain': 'फेरि आवेदन दिनुहोस्',
  'campus.expiredBody': '{campus} को तपाईंको पास सकियो। नवीकरण गर्न फेरि आवेदन दिनुहोस्।',
  'cashback.orderEarned': 'यो अर्डरमा तपाईंले {amount} क्यासब्याक पाउनुभयो 🎉',
  'cashback.expires': 'Capsico Money मा थपियो · {date} मा म्याद सकिन्छ',
  'cashback.hint': 'यो अर्डरमा {percent}% क्यासब्याक 🎉',
  'cashback.hintBody': 'डेलिभरीपछि लगभग {amount} Capsico Money मा फिर्ता।',
  'cashback.walletTitle': 'पाएको क्यासब्याक',
  'cashback.walletTotal': 'योग्य अर्डरमा {percent}% ले अहिलेसम्म {amount}',
  'cashback.order': 'अर्डर #{number}',
  'cashback.orderNoNumber': 'अर्डर',
  'winback.title': 'फेरि स्वागत छ! 🎁',
  'winback.body':
    '{amount} Capsico Money तपाईंलाई पर्खिरहेको छ — {date} भन्दा पहिले प्रयोग गर्नुहोस्।',
  'deeplink.opening': 'खुल्दैछ…',
  'legal.title': 'कानुनी',
  'legal.terms': 'प्रयोगका सर्तहरू',
  'legal.privacy': 'गोपनीयता नीति',
  'legal.refunds': 'फिर्ता र रद्द',
  'legal.cookies': 'कुकी सूचना',
  'legal.restaurantTerms': 'रेस्टुरेन्ट साझेदारका सर्तहरू',
  'legal.riderTerms': 'डेलिभरी साझेदारका सर्तहरू',
  'legal.grievance': 'गुनासो सुन्ने अधिकारी',
  'legal.openSite': 'capsicoeats.com मा खोल्नुहोस्',
  'legal.loadFailed': 'यो कागजात लोड हुन सकेन',
  'legal.loadFailedBody': 'इन्टरनेट जाँच गर्नुहोस्, वा हाम्रो वेबसाइटमा पढ्नुहोस्।',
  'legal.version': 'संस्करण {version}',
  'legal.reconsentTitle': 'हामीले हाम्रा सर्तहरू अद्यावधिक गरेका छौं 📄',
  'legal.reconsentBody': 'के परिवर्तन भयो पढ्नुहोस् र Capsico प्रयोग गरिरहन स्वीकार गर्नुहोस्।',
  'legal.whatChanged': 'के परिवर्तन भयो',
  'legal.read': 'पूरा कागजात पढ्नुहोस्',
  'legal.hide': 'कागजात लुकाउनुहोस्',
  'legal.agree': 'मैले अद्यावधिक कागजातहरू पढेँ र म सहमत छु',
  'legal.accept': 'स्वीकार गर्नुहोस् र अघि बढ्नुहोस्',
  'legal.acceptFailed': 'तपाईंको स्वीकृति सेभ हुन सकेन। फेरि प्रयास गर्नुहोस्।',
  'legal.signOut': 'बरु साइन आउट गर्नुहोस्',
  'update.requiredTitle': 'कृपया एप अपडेट गर्नुहोस्',
  'update.requiredBody': 'यो संस्करण अब सपोर्ट हुँदैन। Capsico चलाइराख्न एप अपडेट गर्नुहोस्।',
  'update.availableTitle': 'नयाँ संस्करण आएको छ',
  'update.availableBody': 'पछिल्ला सुधार र सुविधाहरू पाउन अपडेट गर्नुहोस्।',
  'update.version': 'संस्करण {version}',
  'update.notes': 'नयाँ के छ',
  'update.now': 'अहिले अपडेट गर्नुहोस्',
  'update.update': 'अपडेट गर्नुहोस्',
  'update.reload': 'फेरि लोड गर्नुहोस्',
  'update.later': 'पछि',
  'integrity.title': 'Play Store बाट Capsico इन्स्टल गर्नुहोस्',
  'integrity.body':
    'हामीले यो एपको प्रति प्रमाणित गर्न सकेनौं। अर्डर र भुक्तानीका लागि Google Play बाट आधिकारिक Capsico एप इन्स्टल गर्नुहोस्।',
  'integrity.openStore': 'Play Store खोल्नुहोस्',
  'integrity.retry': 'फेरि प्रयास गर्नुहोस्',
};
